import React from 'react';
import ProverbCard from '../ProverbCard/ProverbCard';
import styles from './ProverbGrid.module.css';

interface Proverb {
  marathi: string;
  literal: string;
  idiomatic: string;
}

interface ProverbGridProps {
  proverbs: Proverb[];
}

const ProverbGrid: React.FC<ProverbGridProps> = ({ proverbs }) => {
  return (
    <div className={styles['proverb-grid-container']}>
      <div
        className={styles['proverb-grid']}
        role="region"
        aria-label="Collection of Marathi proverbs"
      >
        {proverbs.map((proverb, index) => (
          <ProverbCard key={index} proverb={proverb} index={index + 1} />
        ))}
      </div>
    </div>
  );
};

export default ProverbGrid;
